import { Controller } from "@hotwired/stimulus"

// Owns file drags over its element: a child that accepted one keeps it, a dropzone receives it, otherwise it is refused
export default class extends Controller {
  static targets = ["dropzone"]

  dragOver(event) {
    if (this.isFileDrag(event)) {
      event.stopPropagation()

      if (event.defaultPrevented) {
        this.element.removeAttribute("data-dropping")
      } else if (this.hasDropzoneTarget) {
        event.preventDefault()
        this.element.setAttribute("data-dropping", "")
      } else {
        event.preventDefault()
        event.dataTransfer.dropEffect = "none"
      }
    }
  }

  dragLeave(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this.element.removeAttribute("data-dropping")
    }
  }

  drop(event) {
    if (this.isFileDrag(event)) {
      event.stopPropagation()
      this.element.removeAttribute("data-dropping")

      if (!event.defaultPrevented && this.hasDropzoneTarget) {
        event.preventDefault()
        const files = Array.from(event.dataTransfer.files)
        this.dispatch("dropped", { target: this.dropzoneTarget, detail: { files } })
      }
    }
  }

  isFileDrag(event) {
    const types = event.dataTransfer.types
    return types.includes("Files") && !types.includes("application/x-upload-id")
  }
}
